import Vue from 'vue'
import Page from '@/components/pdf-pages/quote-multi-parts'
import sharedInjectedCss from '!!raw-loader!@/components/pdf-pages/css/_shared.css'
import { createPdfPage } from '@/utils/pdf-helpers'

export const generateQuoteMultiParts = async ({ rfq3s, rfq, content, translate }) => {
  const el = document.createElement('div')

  return new Promise((resolve, reject) => {
    return new Vue({
      el,
      template: `
        <page :translate="translate" :rfq="rfq" :rfq3s="rfq3s" :content="content"/>`,
      components: {
        'page': Page
      },
      data: () => ({
        rfq,
        rfq3s,
        content
      }),
      methods: {
        translate
      },
      mounted () {
        resolve(createPdfPage({ injectedCss: [sharedInjectedCss], element: this.$el }))
      },
      errorCaptured (err, vm, info) {
        reject(err)
      }
    })
  })
}
